import React, { useState, useEffect, useReducer } from 'react';
import axios from 'axios';

const apiReducer = (state, action) => {
  switch (action.type) {
    case 'INIT':
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case 'SUCCESS':
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
      };
    case 'FAILURE':
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    default:
      throw new Error();
  }
};

const useApi = () => {
  const { BASE_URL } = process.env;
  const clientId = process.env.APP_CLIENT_ID;

  const user = sessionStorage.getItem('user');
  const currentTime = Math.floor(Date.now() / 1000);
  if (user) {
    const tokenExpired = currentTime > JSON.parse(sessionStorage.user).expiration;
    if (tokenExpired) {
      axios({
        method: 'POST',
        url: `${BASE_URL}/refreshToken`,
        data: { refreshToken: JSON.parse(sessionStorage.user).refreshToken },
        headers: {
          Authorization: JSON.parse(sessionStorage.user).token,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, PATCH, OPTIONS',
        },
      }).then((data) => {
        data.data.response.user = JSON.parse(sessionStorage.user).user;
        data.data.response.organization = JSON.parse(sessionStorage.user).organization;
        data.data.response.project = JSON.parse(sessionStorage.user).project;
        sessionStorage.clear();
        sessionStorage.user = JSON.stringify(data.data.response);
        location.reload();
      });
      // .catch((err) => {
      //   sessionStorage.clear();
      //   history.replace('/');
      // });
    }
  }

  const [url, setUrl] = useState('');
  const [data, setData] = useState(null);
  const [headers, setHeaders] = useState(null);
  const [method, setMethod] = useState('');

  const [state, dispatch] = useReducer(apiReducer, {
    isLoading: false,
    isError: false,
    data,
  });

  const setApiRequest = (url, method, data = null, headers = null) => {
    let _url = url;
    if (_url === '/login') {
      _url = `${_url}?clientId=${clientId}`;
    }
    setMethod(method);
    setData(data);
    setHeaders(headers);
    setUrl(BASE_URL + _url);
  };

  useEffect(() => {
    let didCancel = false;

    const callApi = async () => {
      dispatch({ type: 'INIT' });
      try {
        if (url.includes('/login') || url.includes('/confirmPassword') || url.includes('/resetPassword')) {
          const result = await axios({
            method,
            url,
            data,
            headers: {
              'Access-Control-Allow-Origin': '*',
            },
          });

          if (!didCancel) {
            dispatch({ type: 'SUCCESS', payload: result.data });
          }
        } else {
          let type = 'application/json';
          if (headers === 'multipart/form-data') {
            type = 'multipart/form-data';
          }
          const result = await axios({
            method,
            url,
            data,
            headers: {
              'Content-Type': type,
              Authorization: JSON.parse(sessionStorage.user).token,
              'Access-Control-Allow-Origin': '*',
            },
          });
          if (!didCancel) {
            dispatch({ type: 'SUCCESS', payload: result.data });
          }
        }
      } catch (error) {
        if (!didCancel) {
          dispatch({ type: 'FAILURE' });
        }
      }
      setMethod('');
      setData(null);
      setUrl('');
    };

    if (url && method) callApi();

    return () => {
      didCancel = true;
    };
  }, [url, method, data]);

  return [state, setApiRequest];
};

export default useApi;
